/**
 * Copyright (c) 2026 Farelanes LLC. All rights reserved.
 *
 * UI: Login Button Mobile.
 */

import { useAuth0 } from "@auth0/auth0-react";
import React from "react";

export const LoginButtonMobile = () => {
  const { loginWithRedirect } = useAuth0();

  const handleLogin = async () => {
    await loginWithRedirect({
      appState: {
        returnTo: "/dashboard",
      },
    });
  };

  return (
    <button className="button__login" onClick={handleLogin}>
      sign in
    </button>
  );
};
